import { combineReducers } from "@reduxjs/toolkit";
import { bootstrapReducer } from "./bootstrap/index";
import { fileReducer } from "./file/fileSlice";

import { loadingReducer } from "./loading";
import { projectReducer } from "./project/projectSlice";
import { sidebarReducer } from "./sidebar";
import { uploadReducer } from "./upload/uploadSlice";

import { iraiReducer } from "./irai";
import multiViewerReducer from "./multiViewer.slice";
import treeReducer, { TreeEpics } from "./tree.slice";
import filesListReducer, { FilesListEpics } from "./filesList.slice";
import appReducer from "./app.slice";
import viewer3DReducer, { Viewer3DEpics } from "./viewer3D.slice";

import { uploadFileReducer } from "./uploadFiles/uploadFileSlice";
import fileStatusReducer from "./convertFile/convertFile.slice";
import selectedFilesReducer from "./selectedFiles/selectedFiles.slice";
import drawingsReducer from "@/pages/DrawingsPage/redux/drawingsSlice";
import teamDrivesReducer from "@/store/teamDrives/teamDrivesSlice";
import { extractionReducer } from "@/pages/FilePage/redux/extraction.slice";
import modalReducer from "@/store/modal.slice";
import docaiReducer from "./docai.slice";
import { deleteFileReducer } from "./deleteFile";
import { archiveFileReducer } from "./archiveFile";
import { chatReducer } from "@/pages/Chatbot/redux/chatSlice";
import shareModalReducer from "./shareModal.slice";
import { searchReducer } from "./search";
import permissionReducer from "./permission/permissionSlice";
import organizationUsersReducer from "./organizationUsers/organizationUsersSlice";
import { navigationReducer } from "./navigation/navigationSlice";
import { organizationsReducer } from "./organizations";
import { preferencesReducer } from "./preferences";
import contextMenuReducer from "./contextMenu.slice";
import authReducer from "./auth/authSlice";
import labelReducer from "./labelSlice";
import moveReducer from "./move/moveSlice";
import folderUploadReducer from "./folderUpload/folderUploadSlice";
import rightbarReducer from "./rightbar/rightbarSlice";
import { driveReducer } from "./drive/driveSlice";
import { workflowReducer } from "./workflow/workflowSlice";
import trashPageReducer from "./dataLoader/dataLoaderSlice";
import { workflowAnalyticReducer } from "./workflowAnalytic/workflowAnalyticSlice";
import groupUserReducer from "@/pages/SettingPage/store/groupUserSlice";
import storageReducer from "../pages/SettingPage/StorageManagement/redux/storageSlice";


const mainReducer = combineReducers({
  loading: loadingReducer,
  file: fileReducer,
  bootstrap: bootstrapReducer,
  upload: uploadReducer,
  sidebar: sidebarReducer,
  project: projectReducer,
  drive: driveReducer,
  docai: docaiReducer,
  irai: iraiReducer,
  multiViewer: multiViewerReducer,
  tree: treeReducer,
  filesList: filesListReducer,
  app: appReducer,
  viewer3D: viewer3DReducer,
  fileStatus: fileStatusReducer,
  uploadFile: uploadFileReducer,
  selectedFiles: selectedFilesReducer,
  drawings: drawingsReducer,
  teamDrives: teamDrivesReducer,
  extraction: extractionReducer,
  modal: modalReducer,
  deleteFile: deleteFileReducer,
  archiveFile: archiveFileReducer,
  chat: chatReducer,
  shareModal: shareModalReducer,
  search: searchReducer,
  permission: permissionReducer,
  organizationUsers: organizationUsersReducer,
  navigation: navigationReducer,
  organizations: organizationsReducer,
  preferences: preferencesReducer,
  contextMenu: contextMenuReducer,
  auth: authReducer,
  label: labelReducer,
  move: moveReducer,
  folderUpload: folderUploadReducer,
  rightbar: rightbarReducer,
  workflow: workflowReducer,
  trashPage: trashPageReducer,
  workflowAnalytic: workflowAnalyticReducer,
  groupUser: groupUserReducer,
  storage: storageReducer,
});

const rootReducers = (state: any, action: never) => {
  return mainReducer(state, action);
};

export type RootState = ReturnType<typeof mainReducer>;
export default rootReducers;
